module.exports = __webpack_public_path__ + "static/media/has_containers_full.c367ecd7.svg";